import { type FC } from 'react'

import { F0Button } from '@factorialco/f0-react'
import { Minus, Plus } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

export type QuantityStepperProps = {
  value: number
  onChange: (newValue: number) => void
  min?: number
}

export const QuantityStepper: FC<QuantityStepperProps> = ({ value, onChange, min = 1 }) => {
  return (
    <div className="flex flex-row items-center gap-1">
      <F0Button
        variant="outline"
        size="sm"
        icon={Minus}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label={i18n.t('it_management.device_catalog.cart.quantity_decrease')}
      />
      <input
        type="text"
        readOnly
        value={value}
        className="w-10 text-center border border-solid rounded-md py-1 text-sm"
      />
      <F0Button
        variant="outline"
        size="sm"
        icon={Plus}
        onClick={() => onChange(value + 1)}
        aria-label={i18n.t('it_management.device_catalog.cart.quantity_increase')}
      />
    </div>
  )
}
